import { useCurrentProject } from 'hooks/use-current-project';

import { useTeam } from './use-team';

const useProjectTeam = () => {
    const project = useCurrentProject();

    return useTeam(project?.team);
};

export { useProjectTeam };
